import React, { useEffect, useState } from 'react';
import faqApi from './monash-connect-faq.js';
import { Accordion } from '@monash/portal-react';
import { parseAnswer } from './utils.js';

const Faq = ({ searchTerm, faqIds, title, limit = 0 }) => {
  const [faqResults, setFaqResults] = useState([]);
  const accordionItems = faqResults.map(({ question, answer }) => ({
    title: question,
    content: answer,
  }));

  useEffect(() => {
    const getAllFAQs = async () => {
      if (faqIds && faqIds.length > 0) {
        const resolved = await Promise.all(
          faqIds.map(async (faqId) => {
            const response = await faqApi.searchById(faqId);
            const faqData = response?.data?.data?.[0];

            if (faqData?.question && faqData?.answer) {
              return {
                question: faqData.question,
                answer: parseAnswer(faqData.answer),
              };
            } else {
              console.log('faq not found');
              return null;
            }
          }),
        );
        setFaqResults(resolved.filter((x) => x));
      }
    };
    getAllFAQs();
  }, [faqIds]);

  useEffect(() => {
    if (searchTerm) {
      faqApi
        .searchByQuery(searchTerm)
        .then((response) => {
          const faqArray = [];
          response.data.data.forEach((r) =>
            faqArray.push({
              question: r.question,
              answer: parseAnswer(r.answer),
            }),
          );
          setFaqResults(faqArray);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [searchTerm]);
  return faqResults?.length > 0 ? (
    <Accordion sectionTitle={title} items={accordionItems} />
  ) : null;
};

export default Faq;
